import { render, staticRenderFns } from "./failureDetail.vue?vue&type=template&id=22e074f9&scoped=true"
import script from "./failureDetail.vue?vue&type=script&lang=js"
export * from "./failureDetail.vue?vue&type=script&lang=js"
import style0 from "./failureDetail.vue?vue&type=style&index=0&id=22e074f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_77a37368fa9f7d737cecfb85aa182826/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e074f9",
  null
  
)

export default component.exports